import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  Icon,
  Textarea,
  Flex,
  Box,
  useToast
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { AiFillPlusCircle, AiOutlineArrowLeft } from 'react-icons/ai';
import { Button } from '../../../../../../components/Button';
import { FaEdit } from 'react-icons/fa';
import { useForm } from 'react-hook-form';
import { api } from '../../../../../../services/api';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

async function atualizarObservacaoCliente({ codParc, obsCliente }) {
  const response = await api.put(`/site/v2/orcamento-crm/atualiza-observacao-cliente`, {
    codigo_parceiro: codParc,
    observacao_cliente: obsCliente
  });

  return response.data;
}

export function ObservacoesCliente({ obs, infoProposta }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isReadyOnly, setIsReadyOnly] = React.useState(true);
  const btnRef = React.useRef();
  const { numeroProposta: numProposta } = useParams();

  const { register, handleSubmit, setValue } = useForm();

  const queryClient = useQueryClient();

  const toast = useToast({
    position: 'top-right',
    isClosable: true
  });

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (data) =>
      atualizarObservacaoCliente({
        codParc: data.codParc,
        obsCliente: data.obsCliente
      }),
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (old) => {
        return {
          ...old,
          observacao_cliente: data.observacao_cliente
        };
      });

      toast({
        title: 'Observação atualizada com sucesso',
        status: 'success',
        duration: 3000
      });
    },
    onError: (error) => {
      toast({
        title: 'Erro ao atualizar observação',
        description: error['response']['data'].erros.map((erro) => erro),
        status: 'error'
      });
    }
  });

  async function handleUpdateObservacaoCliente(data) {
    const params = {
      codParc: infoProposta.cliente.codigo_parceiro,
      obsCliente: data.obs
    };

    await mutateAsync(params);
  }

  useEffect(() => {
    setValue('obs', obs);
  }, [obs, setValue]);

  return (
    <>
      <Icon
        as={AiFillPlusCircle}
        color="#378BBF"
        fontSize="20px"
        onClick={onOpen}
        ref={btnRef}
        cursor="pointer"
      />
      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader
            bgColor="#378BBF"
            textAlign="center"
            color="#F5F5F5"
            textTransform="uppercase">
            Obs Cliente
          </DrawerHeader>

          <DrawerBody
            maxW="620px"
            w="full"
            mx="auto"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            gap="21px"
            as="form"
            onSubmit={handleSubmit(handleUpdateObservacaoCliente)}>
            <Box position="relative" w="100%">
              <Textarea
                readOnly={isReadyOnly}
                size="sm"
                h="120px"
                fontSize="12px"
                resize={'none'}
                lineHeight="20px"
                letterSpacing="0.6px"
                //quando ready only for true, deixa o background cinza
                bgColor={isReadyOnly ? '#F5F5F5' : 'white'}
                border="1px solid"
                _hover={{ borderColor: '#F5F5F5' }}
                _focus={{ borderColor: '#F5F5F5' }}
                borderColor={isReadyOnly ? '#F5F5F5' : '#939393'}
                {...register('obs')}
              />
              <Flex
                position="absolute"
                right="10px"
                bottom="10px"
                cursor="pointer"
                alignItems="center"
                justifyContent="center"
                gap={2}
                onClick={() => setIsReadyOnly(!isReadyOnly)}
                fontSize="12px"
                color="#378BBF">
                Editar
                <Icon as={FaEdit} fontSize="16px" />
              </Flex>
            </Box>

            <Flex alignItems="center" justifyContent="space-between" w="100%">
              <Button
                maxW="181px"
                w="100%"
                fontSize="15px"
                fontWeight="semibold"
                bgColor="transparent"
                color="#FFA200"
                border="1px solid #FFA200"
                //fecha modal
                onClick={onClose}>
                <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                Voltar
              </Button>
              <Button
                maxW="181px"
                w="100%"
                fontSize="15px"
                fontWeight="semibold"
                disabled={isReadyOnly}
                sx={{
                  //disabled
                  _disabled: {
                    bgColor: '#F5F5F5',
                    color: '#939393',
                    cursor: 'not-allowed'
                  }
                }}
                type="submit">
                salvar alteração
              </Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
